
<template>
  <div class="spinner">
    <div class="ball top"></div>
    <div class="ball left"></div>
    <div class="ball right"></div>
    <div class="ball bottom"></div>
  </div>
</template>

<script>

    export default {
    };
</script>

<style lang="scss" scoped>

@import '../../scss/settings';

.spinner {
    position: absolute;
    width: 4rem;
    height: 4rem;
    top: 50%;
    left: 50%;
    margin-left: -4rem;
    animation: spin .8s infinite linear;
 
    .ball {
        position: absolute;
        border-radius: 50%;
        //border: .35rem solid $color__primary;
 

        &.top {
            margin-left: -.35rem;
            top: 0;
            left: 50%;
            animation: ball-top 2.5s 1.25s infinite ease-in-out;
        }
        

        &.bottom {
            bottom: 0;
            left: 50%;
            animation: ball-bottom 2.5s 1.25s infinite ease-in-out;
            margin-left: -.35rem;
        }

        &.left {
            left: 0;
            top: 50%;
            animation: ball-left 2.5s infinite ease-in-out;
            margin-top: -.35rem;
        }
    
        &.right {
            right: 0;
            top: 50%;
            margin-top: -.35rem;
            animation: ball-right 2.5s infinite ease-in-out;
        }

        @keyframes spin {
            0% { 
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            } 
        }


        @keyframes ball-top {
            20% {
                opacity: 1;
            }
            40% {
                opacity: .5;
            }
            50% {
                transform: translateY(1.5rem);
                border-color: #ccc;
                opacity: 0;
            }

            75% {
                transform: translateY(0rem);
                opacity: .5;
            }
            
            100% {
                border-color: $color__primary;
                opacity: 1;
              
            }
        }

        @keyframes ball-bottom {
            50% {
              transform: translateY(-1.5rem);
              border-color: #ccc;
              opacity: .5;
            }
            75% {
                transform: translateY(0rem);
                opacity: 1;
            }
            100% {
                border-color: $color__primary;

            }
        }

        @keyframes ball-left {
            50% {
              transform: translateX(1.5rem);
              border-color: #ccc;
              opacity: .5;
            }
            75% {
                transform: translateX(0);
                opacity: 1;
            }
            100% {
              border-color: $color__primary;
            }
        }

        @keyframes ball-right {
            20% {
                opacity: 1;
            }
            40% {
                opacity: .5;
            }
           50% {
              transform: translateX(-1.5rem);
              border-color: #ccc;
              opacity: 0;
            }
            75% {
                transform: translateX(0);
                opacity: .5;
            }
            100% {
              border-color: $color__primary;
              opacity: 1;
            }
        }

    }
}
</style>